import React from 'react'
import PropTypes from 'prop-types'
import { GatsbyImage } from 'gatsby-plugin-image'
import { keyframes } from '@emotion/react'
import { Grid, Box } from 'theme-ui'
import StyledWrapper from '~/components/Generic/StyledWrapper'

import Heading from '~/components/IntlComponents/Heading'

import Text from '~/components/IntlComponents/Text'

const MacDish = ({
  bowlImage,
  valuePropHeading,
  valuePropSubheading,
  valuePropImage,
  extendedStyles,
}) => {
  const leftValuePropImages = valuePropImage.valuePropImage.slice(0, 3)
  const rightValuePropImages = valuePropImage.valuePropImage.slice(3, 6)

  return (
    <Box sx={{ ...extendedStyles }}>
      <StyledWrapper>
        <Heading
          sx={{
            width: ['85%', 'auto'],
            maxWidth: 800,
            pt: 96,
            mx: 'auto',
            mb: 12,
          }}
          variant="text.h2"
        >
          {valuePropHeading}
        </Heading>
      </StyledWrapper>
      <StyledWrapper>
        <Text
          as="p"
          sx={{
            width: ['85%', 'auto'],
            maxWidth: 680,
            marginBottom: 60,
            fontSize: 18,
            px: '10px',
            mx: 'auto',
          }}
        >
          {valuePropSubheading}
        </Text>
      </StyledWrapper>
      <ValuePropWithImage
        image={bowlImage.gatsbyImageData}
        leftValuePropImages={leftValuePropImages}
        rightValuePropImages={rightValuePropImages}
      ></ValuePropWithImage>
    </Box>
  )
}

const ValuePropWrapper = ({ justifySelf, imgObj }) => {
  const floatAnimObj = (distance, duration) => {
    const float = keyframes`
    0% { transform: translate(0%,  0px); }
    50%  { transform: translate(0, -${distance}px); }
    100%   { transform: translate(0, 0px); }
    `
    return {
      animation: `${float} ${duration}ms infinite ease-in-out`,
    }
  }

  return (
    <Box
      sx={{
        width: 'fit-content',
        justifySelf: ['center', justifySelf],
      }}
    >
      <Grid
        sx={{
          width: ['auto', 120],
          height: ['150px', 'auto'],
          margin: 'auto',
          ...floatAnimObj(15, 6000 + Math.random() * 1000),
        }}
      >
        <GatsbyImage
          imgStyle={{ objectFit: 'contain' }}
          image={imgObj.gatsbyImageData}
          alt={imgObj.title}
        />
        <Text variant="text.eyebrow">{imgObj.title}</Text>
      </Grid>
    </Box>
  )
}

const ValuePropWithImage = ({
  leftValuePropImages,
  rightValuePropImages,
  image,
}) => {
  return (
    <Grid
      columns={[
        1,
        ' minmax(120px,200px)  minmax(0px,700px) minmax(120px,200px)',
      ]}
    >
      <Grid
        columns={[3, 1]}
        sx={{
          width: ['90%', '100%'],
          maxWidth: ['100%', 200],
          justifySelf: ['center', 'end'],
        }}
      >
        {leftValuePropImages.map((imgObj, i) => {
          return (
            <ValuePropWrapper
              justifySelf={i === 1 ? 'start' : 'end'}
              imgObj={imgObj}
              key={i}
            ></ValuePropWrapper>
          )
        })}
      </Grid>
      <Box sx={{ width: ['85%', '100%'], justifySelf: 'center' }}>
        <GatsbyImage image={image} alt={image?.title} />
      </Box>
      <Grid
        columns={[3, 1]}
        sx={{
          width: ['90%', '100%'],
          maxWidth: ['100%', 200],
          justifySelf: ['center'],
        }}
      >
        {rightValuePropImages.map((imgObj, i) => {
          return (
            <ValuePropWrapper
              justifySelf={i === 1 ? 'end' : 'start'}
              imgObj={imgObj}
              key={i}
            ></ValuePropWrapper>
          )
        })}
      </Grid>
    </Grid>
  )
}

ValuePropWithImage.propTypes = {
  leftValuePropImages: PropTypes.array.isRequired,
  rightValuePropImages: PropTypes.array.isRequired,
  gatsbyImageData: PropTypes.object.isRequired,
}

MacDish.propTypes = {
  bowlImage: PropTypes.object.isRequired,
  valuePropHeading: PropTypes.string.isRequired,
  valuePropSubheading: PropTypes.string.isRequired,
  valuePropImage: PropTypes.object.isRequired,
  extendedStyles: PropTypes.object,
}

export default MacDish
